<div class="modal-backdrop fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4"
    [ngClass]="isSheetView ? 'max-[576px]:p-0 max-[576px]:items-end' : 'max-[576px]:p-3'" *ngIf="isOpen">
    <div class="modal-panel bg-white rounded-2xl p-[30px] w-full max-w-xl relative max-[576px]:p-5"
        [ngClass]="isSheetView
            ? 'login-sheet max-[576px]:max-w-none max-[576px]:rounded-b-none max-[576px]:pb-[calc(1.25rem+env(safe-area-inset-bottom))]'
            : ''">
        <button
            class="modal-close w-[37px] h-[37px] shrink-0 z-10 text-[#000000cc] flex items-center justify-center absolute -top-3 -right-3 bg-[#E9E9E9] hover:bg-[#000000cc] hover:text-white duration-300 ease-in-out rounded-full cursor-pointer"
            [ngClass]="(isSheetView ? 'max-[576px]:w-8 max-[576px]:h-8 max-[576px]:top-3 max-[576px]:right-3 max-[576px]:bg-transparent ' : '')
                + (showContactSupport ? 'max-[576px]:hidden' : '')"
            (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177" stroke="currentColor"
                    stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <div
            class="max-h-[calc(100vh-10rem)] max-[576px]:max-h-[calc(100dvh-8rem)] overflow-y-auto overflow-x-hidden custom-scroll">

        <ng-container *ngIf="operation == 'tfa_auth'">
            <div class="flex flex-col gap-8 max-[576px]:gap-4 text-center">

                <!-- Lock Icon -->
                <div
                    class="mx-auto max-[576px]:mx-0 w-[70px] h-[70px] max-[576px]:w-10 max-[576px]:h-10 max-[576px]:p-2 shrink-0 block max-[576px]:flex max-[576px]:items-center max-[576px]:justify-center max-[576px]:rounded-full max-[576px]:border max-[576px]:border-light-black-200">
                    <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" width="70" height="70"
                        viewBox="0 0 70 70" fill="none">
                        <path d="M42.2602 45.207H42.2865M27.7031 45.207H27.7293" stroke="black" stroke-opacity="0.8"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M12.453 54.9637C13.1089 59.8354 17.1439 63.6519 22.0542 63.8776C26.186 64.0675 30.3832 64.1667 35.0052 64.1667C39.6273 64.1667 43.8243 64.0675 47.9561 63.8776C52.8666 63.6519 56.9015 59.8354 57.5575 54.9637C57.9856 51.7845 58.3385 48.5263 58.3385 45.2083C58.3385 41.8903 57.9856 38.6321 57.5575 35.453C56.9015 30.5813 52.8666 26.7648 47.9561 26.539C43.8243 26.3491 39.6273 26.25 35.0052 26.25C30.3832 26.25 26.186 26.3491 22.0542 26.539C17.1439 26.7648 13.1089 30.5813 12.453 35.453C12.0249 38.6321 11.6719 41.8903 11.6719 45.2083C11.6719 48.5263 12.0249 51.7845 12.453 54.9637Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M21.875 26.2487V18.957C21.875 11.7083 27.7513 5.83203 35 5.83203C42.2488 5.83203 48.125 11.7083 48.125 18.957V26.2487"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="modal-heading text-lg md:text-xl lg:text-2xl text-black font-bold mb-2 max-[576px]:mb-1">
                        Enter authenticator code
                    </h3>
                    <p class="text-base max-[576px]:text-sm font-medium text-secondary-text-black">
                        Please enter the 6-digit code from authenticator app.
                    </p>
                </div>
                <div class="flex justify-center w-full otp-wrapper">
                    <ng-otp-input [config]="otpConfig" (onInputChange)="onOtpChange($event)"></ng-otp-input>
                </div>

                <p class="text-black font-semibold text-lg max-[576px]:text-sm cursor-pointer"
                    (click)="openRecoveryModal()">I Lost My
                    Device</p>

                <!-- Next (mobile sheet design) -->
                <button (click)="verifyMFACode()" [disabled]="otp.length !== 6 || isVerifying"
                    class="hidden max-[576px]:block w-full text-sm font-syne bg-black text-white py-3 rounded-xl font-semibold duration-200 ease-in-out cursor-pointer disabled:bg-secondary-button-black disabled:text-secondary-text-black disabled:cursor-not-allowed">
                    Next
                </button>

            </div>
        </ng-container>

        <!-- Recovery-Modal -->
        <ng-container *ngIf="isOpenRecoveryModalShow">
            <div class="flex flex-col gap-8 max-[576px]:gap-4 text-center relative">
                <!-- The key sits at the left at both widths; the sheet rings it -->
                <div
                    class="w-[45px] h-[45px] max-[576px]:w-10 max-[576px]:h-10 max-[576px]:p-2 shrink-0 block max-[576px]:flex max-[576px]:items-center max-[576px]:justify-center max-[576px]:rounded-full max-[576px]:border max-[576px]:border-light-black-200">
                    <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" width="70" height="70"
                        viewBox="0 0 70 70" fill="none">
                        <path
                            d="M45.2057 42.291C54.8707 42.291 62.7057 34.456 62.7057 24.791C62.7057 15.126 54.8707 7.29102 45.2057 7.29102C35.5408 7.29102 27.7057 15.126 27.7057 24.791C27.7057 27.3589 28.2588 29.7975 29.2524 31.9943L7.28906 53.9577V62.7077H16.0391V56.8744H21.8724V51.041H27.7057L38.0024 40.7443C40.1993 41.738 42.6379 42.291 45.2057 42.291Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M51.0417 18.959L48.125 21.8757" stroke="black" stroke-opacity="0.8" stroke-width="3"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="modal-heading text-lg md:text-xl lg:text-2xl text-black font-bold mb-2 max-[576px]:mb-1">
                        Enter Recovery code
                    </h3>
                    <p class="text-base max-[576px]:text-sm font-medium text-secondary-text-black">
                        To log in enter your recovery code you saved while 2FA .
                    </p>
                </div>
                <!-- The code is typed into one full-width field, at both widths -->
                <input type="text" [(ngModel)]="otp" autocomplete="one-time-code" autocapitalize="characters"
                    spellcheck="false" placeholder="Enter the recovery code"
                    class="w-full min-w-0 text-sm font-medium text-black placeholder:text-[#00000059] bg-light-black-300 border border-transparent rounded-xl p-3.5 focus:outline-none focus:border-[#00000066]" />

                <p class="text-black font-semibold text-sm cursor-pointer" (click)="openContactSupport()">
                    I Lost My Recovery Code
                </p>

                <button (click)="verifyRecoveryCode()" [disabled]="!isRecoveryCodeComplete"
                    class="w-full text-sm font-syne bg-black text-white py-3 rounded-xl font-semibold duration-200 ease-in-out cursor-pointer disabled:bg-secondary-button-black disabled:text-secondary-text-black disabled:cursor-not-allowed">
                    Next
                </button>

            </div>
        </ng-container>

        <!-- Contact-Blockchain-Modal -->
        <ng-container *ngIf="showContactSupport">
            <div class="flex flex-col gap-8 max-[576px]:gap-4 text-center relative">
                <!-- Mobile only: dismisses the sheet outright. The user stays as they
                     were - no session is created, so they are not logged in. -->
                <button type="button" (click)="close()" aria-label="Close"
                    class="hidden max-[576px]:flex items-center justify-center absolute right-0 top-0 w-8 h-8 shrink-0 text-[#000000cc] cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M12.0418 0.708374L0.709261 12.041M12.0411 12.0417L0.708496 0.709177"
                            stroke="currentColor" stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>

                <button (click)="closeContactSupport()"
                    class="flex items-center justify-center absolute left-0 top-0 w-[37px] h-[37px] max-[576px]:hidden shrink-0 text-secondary-text-black bg-light-black-100 rounded-full hover:text-white hover:bg-black duration-200 ease-in-out cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path d="M3.46875 9.50146H16.0015" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M8.57006 15.0714C8.57006 15.0714 3.00001 10.969 3 9.50123C2.99999 8.03341 8.57015 3.93115 8.57015 3.93115"
                            stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>

                <div
                    class="mx-auto max-[576px]:mx-0 w-[70px] h-[70px] max-[576px]:w-10 max-[576px]:h-10 max-[576px]:p-2 shrink-0 block max-[576px]:flex max-[576px]:items-center max-[576px]:justify-center max-[576px]:rounded-full max-[576px]:border max-[576px]:border-light-black-200 text-black">
                    <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" fill="none">
                        <path
                            d="M11.6719 43.75V35C11.6719 22.1134 22.1186 11.6667 35.0052 11.6667C47.8918 11.6667 58.3385 22.1134 58.3385 35V43.75"
                            stroke="currentColor" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M11.6719 43.75C11.6719 39.7229 14.9365 36.4583 18.9635 36.4583C21.3792 36.4583 23.3385 38.4176 23.3385 40.8333V49.5833C23.3385 51.999 21.3792 53.9583 18.9635 53.9583C14.9365 53.9583 11.6719 50.6938 11.6719 46.6667V43.75Z"
                            stroke="currentColor" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M58.3385 43.75C58.3385 39.7229 55.0739 36.4583 51.0469 36.4583C48.6312 36.4583 46.6719 38.4176 46.6719 40.8333V49.5833C46.6719 51.999 48.6312 53.9583 51.0469 53.9583C55.0739 53.9583 58.3385 50.6938 58.3385 46.6667V43.75Z"
                            stroke="currentColor" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M55.4219 53.9583C55.4219 58.7908 50.1969 61.25 43.7552 61.25" stroke="currentColor"
                            stroke-opacity="0.8" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

                <!-- Centred on the panel, left-aligned in the sheet, matching the icon
                     above it: centred at full width, at the left edge below 576px -->
                <div class="w-full max-[576px]:text-left">
                    <h3 class="modal-heading text-lg md:text-xl lg:text-2xl text-black font-bold mb-2 max-[576px]:mb-1">
                        Contact BlockchainX Support
                    </h3>
                    <p class="text-base max-[576px]:text-sm font-medium text-secondary-text-black">
                        For help recovering your account, please contact the BlockchainX support team.
                    </p>
                </div>

                <a [href]="'mailto:' + supportEmail"
                    class="flex items-center justify-center w-full text-base max-[576px]:text-sm font-syne bg-black text-white border border-transparent hover:text-black hover:bg-white hover:border-black py-3 rounded-xl font-semibold duration-300 ease-in-out cursor-pointer">
                    Contact Support
                </a>
            </div>
        </ng-container>

        <ng-container *ngIf="showDisableTFAStatus">
            <div class="flex flex-col gap-6 max-[576px]:gap-4 text-center">
                <!-- the sheet design draws the tick as an outlined ring instead of a filled disc -->
                <div
                    class="flex items-center justify-center w-[70px] h-[70px] max-[576px]:w-10 max-[576px]:h-10 shrink-0 mx-auto max-[576px]:mx-0 rounded-full bg-primary-text-green text-white max-[576px]:bg-transparent max-[576px]:border max-[576px]:border-primary-text-green max-[576px]:text-primary-text-green">
                    <svg class="w-[42px] h-[42px] max-[576px]:w-5 max-[576px]:h-5" xmlns="http://www.w3.org/2000/svg"
                        width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <path
                            d="M8.75 25.375C8.75 25.375 11.375 25.375 14.875 31.5C14.875 31.5 24.6029 15.4583 33.25 12.25"
                            stroke="currentColor" stroke-width="2.625" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="text-center max-[576px]:text-left">
                    <h3 class="modal-heading text-lg md:text-xl lg:text-2xl text-black font-bold mb-2 max-[576px]:mb-1">
                        Recovery Successful
                    </h3>
                    <p class="text-base max-[576px]:text-sm font-medium text-secondary-text-black">
                        Your recovery code has been verified, and two-factor authentication has been disabled for your
                        account.
                    </p>
                </div>
            </div>
        </ng-container>

        <!-- 2FA verified successfully -->
        <ng-container *ngIf="showTfaSuccess">
            <div class="flex flex-col gap-6 max-[576px]:gap-4 text-center">
                <div
                    class="flex items-center justify-center w-[70px] h-[70px] max-[576px]:w-10 max-[576px]:h-10 shrink-0 mx-auto max-[576px]:mx-0 rounded-full border-2 max-[576px]:border border-primary-text-green text-primary-text-green">
                    <svg class="w-[42px] h-[42px] max-[576px]:w-6 max-[576px]:h-6" xmlns="http://www.w3.org/2000/svg"
                        width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <path
                            d="M8.75 25.375C8.75 25.375 11.375 25.375 14.875 31.5C14.875 31.5 24.6029 15.4583 33.25 12.25"
                            stroke="currentColor" stroke-width="2.625" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="text-center max-[576px]:text-left">
                    <h3 class="modal-heading text-lg md:text-xl lg:text-2xl text-black font-bold mb-2 max-[576px]:mb-1">
                        Authentication Successful
                    </h3>
                    <p class="text-base max-[576px]:text-sm font-medium text-secondary-text-black">
                        Your six-digit authentication code has been verified successfully. You can now continue
                        securely.
                    </p>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="operation == 'login'">

            <h2 class="modal-heading text-black text-2xl max-[576px]:text-lg font-bold mb-2 max-[576px]:mb-1">Welcome to
                Prediction Market</h2>
            <!-- <p class="text-base text-[#00000099] font-medium">Already have an account? <a href="#"
                class="text-black font-semibold">Login</a></p> -->

            <button
                class=" flex items-center justify-center gap-2.5 text-base max-[576px]:text-sm font-syne font-semibold w-full bg-black text-white border border-transparent hover:text-black hover:bg-white hover:border hover:border-black duration-300 ease-in-out p-3 max-[576px]:py-2.5 rounded-xl cursor-pointer my-6 max-[576px]:my-4"
                (click)="loginAction('social_login', 'web2', 'google')">
                <svg class="shrink-0 max-[576px]:w-4 max-[576px]:h-4" xmlns="http://www.w3.org/2000/svg" width="20"
                    height="20" viewBox="0 0 20 20" fill="none">
                    <g clip-path="url(#clip0_4647_39677)">
                        <path
                            d="M4.43242 12.0863L3.73625 14.6852L1.19176 14.739C0.431328 13.3286 0 11.7149 0 10C0 8.34179 0.403281 6.77804 1.11813 5.40112H1.11867L3.38398 5.81644L4.37633 8.06815C4.16863 8.67366 4.05543 9.32366 4.05543 10C4.05551 10.7341 4.18848 11.4374 4.43242 12.0863Z"
                            fill="currentColor" />
                        <path
                            d="M19.8252 8.13184C19.94 8.73676 19.9999 9.36148 19.9999 9.99996C19.9999 10.7159 19.9246 11.4143 19.7812 12.0879C19.2944 14.3802 18.0224 16.3818 16.2604 17.7983L16.2598 17.7978L13.4065 17.6522L13.0027 15.1313C14.1719 14.4456 15.0857 13.3725 15.567 12.0879H10.2197V8.13184H15.645H19.8252Z"
                            fill="currentColor" />
                        <path
                            d="M16.26 17.7978L16.2606 17.7984C14.5469 19.1758 12.3699 20 10.0001 20C6.19189 20 2.88092 17.8715 1.19189 14.739L4.43256 12.0863C5.27705 14.3401 7.45123 15.9445 10.0001 15.9445C11.0957 15.9445 12.1221 15.6484 13.0029 15.1313L16.26 17.7978Z"
                            fill="currentColor" />
                        <path
                            d="M16.383 2.30219L13.1434 4.95438C12.2319 4.38461 11.1544 4.05547 10 4.05547C7.39344 4.05547 5.17859 5.73348 4.37641 8.06813L1.11871 5.40109H1.11816C2.78246 2.19231 6.1352 0 10 0C12.4264 0 14.6511 0.864297 16.383 2.30219Z"
                            fill="currentColor" />
                    </g>
                    <defs>
                        <clipPath id="clip0_4647_39677">
                            <rect width="20" height="20" fill="currentColor" />
                        </clipPath>
                    </defs>
                </svg>
                Continue With Google
            </button>

            <div class="flex items-center gap-3 mb-6 max-[576px]:mb-4">
                <span class="flex-1 h-px bg-secondary-button-black"></span>
                <span class="text-base max-[576px]:text-sm font-syne font-medium text-secondary-text-black">OR</span>
                <span class="flex-1 h-px bg-secondary-button-black"></span>
            </div>

            <div class="relative mb-5 max-[576px]:mb-4" [formGroup]="loginForm">
                <!-- below 575px the Continue button drops out of the field and sits under the wallet
                     options, so the input takes the full width and loses the button padding -->
                <input type="email" placeholder="Enter Email" formControlName="email" class="w-full text-base font-normal placeholder:text-[#00000059]
           border border-secondary-button-black rounded-lg
           p-[18px] pr-[140px]
           max-[576px]:text-sm max-[576px]:p-3.5 max-[576px]:pr-3.5
           focus:outline-none focus:border-[#00000066]"
                    [ngClass]="{'border-red-500': loginForm.get('email')?.invalid && loginForm.get('email')?.touched}" />

                <button (click)="loginAction('email_link', 'web2')" [disabled]="loginForm.invalid" class="absolute top-2 right-2 rounded-md py-2.5 px-6 font-semibold font-syne cursor-pointer
           text-white bg-black
           transition-all duration-300 ease-in-out
           disabled:opacity-20 disabled:cursor-not-allowed
           disabled:pointer-events-none
           max-[576px]:hidden">
                    Continue
                </button>
                <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    class="text-red-500 text-xs mt-1 absolute -bottom-5 left-0">
                    <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</span>
                    <span *ngIf="loginForm.get('email')?.errors?.['email']
    || loginForm.get('email')?.errors?.['pattern']">
                        Please enter a valid email address
                    </span>
                </div>
            </div>

            <ul class="flex justify-between gap-5 max-[576px]:gap-2.5">
                <li class="w-full min-w-0 block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3', 'metaMask')"
                        class="w-full h-[60px] max-[576px]:h-12 flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img class="max-w-full max-[576px]:w-6 max-[576px]:h-6" src="assets/icons/login-image1.svg">
                    </a>
                </li>
                <li class="w-full min-w-0 block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3', 'walletConnect')"
                        class="w-full h-[60px] max-[576px]:h-12 flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img class="max-w-full max-[576px]:w-6 max-[576px]:h-6" src="assets/icons/login-image2.svg">
                    </a>
                </li>
                <li class="w-full min-w-0 block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3')"
                        class="w-full h-[60px] max-[576px]:h-12 flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img class="max-w-full max-[576px]:w-6 max-[576px]:h-6" src="assets/icons/login-image3.svg">
                    </a>
                </li>
                <li class="w-full min-w-0 block">
                    <a href="javascript:void(0)" (click)="loginAction('wallet_option', 'web3')"
                        class="w-full h-[60px] max-[576px]:h-12 flex items-center justify-center text-center bg-light-black-300 rounded-lg">
                        <img class="max-w-full max-[576px]:w-6 max-[576px]:h-6" src="assets/icons/login-image4.svg">
                    </a>
                </li>
            </ul>

            <!-- Continue (mobile only): grey while the email is empty or incomplete, black once valid -->
            <button (click)="loginAction('email_link', 'web2')" [disabled]="loginForm.invalid"
                class="hidden max-[576px]:block w-full mt-4 text-sm font-syne font-semibold py-3 rounded-xl cursor-pointer bg-black text-white duration-200 ease-in-out disabled:bg-secondary-button-black disabled:text-secondary-text-black disabled:cursor-not-allowed">
                Continue
            </button>

        </ng-container>

        </div>
    </div>
</div>